import React, { Component } from 'react'
import { translate } from 'react-polyglot'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { settingsActions } from 'features/settings'
import { authActions } from 'features/auth'

import { Button, Confirm, FlexContainer, Loader, Modal } from 'components'

import TeamSettingsForm from './TeamSettingsForm'
import CreateTeamForm from './CreateTeamForm'
import ChangeSlugForm from './ChangeSlugForm'
// import AdvancedTeamSettingsForm from './AdvancedTeamSettingsForm'

class TeamPage extends Component {
	constructor(props) {
		super(props)

		this.state = {
			createTeamModalOpen: props.openCreateTeam,
			changeSlugModalOpen: false,
		}

		this.timer = null
	}

	componentDidMount() {
		// Reset loading state
		// this.props.setLoadingState(true)
		// @TODO: Right now content usually is always there
		// Later: let the reducer handle reset of loading state
		// setTimeout(() => {
		// 	this.props.setLoadingState(false)
		// }, 1000)

		window.addEventListener('beforeunload', this.beforeUnload)
	}

	componentWillUnmount() {
		window.removeEventListener('beforeunload', this.beforeUnload)
	}

	beforeUnload = event => {
		if (!this.timer) return

		const confirmationMessage = this.ON_LEAVE_MESSAGE

		event.returnValue = confirmationMessage // Gecko, Trident, Chrome 34+

		return confirmationMessage
	}

	toggleCreateTeamModal = () => {
		const { createTeamModalOpen } = this.state

		this.setState({ createTeamModalOpen: !createTeamModalOpen })
	}

	handleCreateTeamSubmit = values => {
		const { createTeam } = this.props

		createTeam(values)
	}

	handleTeamSettingsSubmit = values => {
		clearTimeout(this.timer)

		this.timer = setTimeout(() => {
			const { updateTeamName } = this.props
			const { teamName } = values

			updateTeamName(teamName)

			this.timer = null
		}, 500)
	}

	handleAdvancedTeamSettingsSubmit = values => {}

	onUploadTeamImage = event => {
		event.preventDefault()

		const { updateTeamImage, t } = this.props

		const file = document.getElementById('team-image-input')

		if (file.files[0].type.match('image.*')) {
			updateTeamImage(file.files[0])
		} else {
			alert(t('forms.please_select_valid_image'))
		}

		event.target.value = ''
	}

	onUploadTeamLogo = event => {
		event.preventDefault()

		const { updateTeamLogo, t } = this.props

		const file = document.getElementById('team-logo-input')

		if (file.files[0].type.match('image.*')) {
			updateTeamLogo(file.files[0])
		} else {
			alert(t('forms.please_select_valid_image'))
		}

		event.target.value = ''
	}

	onUploadTeamLogoNegative = event => {
		event.preventDefault()

		const { updateTeamLogoNegative, t } = this.props

		const file = document.getElementById('team-logo-negative-input')

		if (file.files[0].type.match('image.*')) {
			updateTeamLogoNegative(file.files[0])
		} else {
			alert(t('forms.please_select_valid_image'))
		}

		event.target.value = ''
	}

	onUploadTeamFavicon = event => {
		event.preventDefault()

		const { updateTeamFavicon, t } = this.props

		const file = document.getElementById('team-favicon-input')

		if (file.files[0].type.match('image.*')) {
			updateTeamFavicon(file.files[0])
		} else {
			alert(t('forms.please_select_valid_image'))
		}

		event.target.value = ''
	}

	changeTeamColorScheme = value => {
		const { updateScheme } = this.props

		updateScheme(value)
	}

	toggleChangeSlugModal = () => {
		const { changeSlugModalOpen } = this.state

		this.setState({ changeSlugModalOpen: !changeSlugModalOpen })
	}

	handleChangeSlugSubmit = values => {
		const { updateSlug } = this.props
		const { teamUrl, password } = values

		updateSlug(teamUrl, password)
	}

	render() {
		const {
			loading,
			team,
			teamUrl,
			teamImage,
			teamImageUploadPending,
			teamImageUploadSuccessful,
			teamLogo,
			teamLogoUploadPending,
			teamLogoUploadSuccessful,
			teamLogoNegative,
			teamLogoNegativeUploadPending,
			teamLogoNegativeUploadSuccessful,
			teamFavicon,
			teamFaviconUploadPending,
			teamFaviconUploadSuccessful,
			openCreateTeam,
			teamColorScheme,
			t,
		} = this.props

		const { createTeamModalOpen } = this.state

		if (!teamUrl) return <Loader />

		return (
			<>
				<FlexContainer>
					<h2>{t('settings.team_settings')}</h2>
					<FlexContainer justifyContent="flex-end">
						<Button
							text={t('settings.create_team')}
							size="small"
							layout="secondary"
							onClick={() => {
								this.toggleCreateTeamModal()
							}}
						/>
					</FlexContainer>
				</FlexContainer>
				<TeamSettingsForm
					teamImage={teamImage}
					teamImageUploadPending={teamImageUploadPending}
					teamImageUploadSuccessful={teamImageUploadSuccessful}
					onUploadTeamImage={this.onUploadTeamImage}
					teamLogo={teamLogo}
					teamLogoUploadPending={teamLogoUploadPending}
					teamLogoUploadSuccessful={teamLogoUploadSuccessful}
					onUploadTeamLogo={this.onUploadTeamLogo}
					teamLogoNegative={teamLogoNegative}
					teamLogoNegativeUploadPending={
						teamLogoNegativeUploadPending
					}
					teamLogoNegativeUploadSuccessful={
						teamLogoNegativeUploadSuccessful
					}
					onUploadTeamLogoNegative={this.onUploadTeamLogoNegative}
					teamFavicon={teamFavicon}
					teamFaviconUploadPending={teamFaviconUploadPending}
					teamFaviconUploadSuccessful={teamFaviconUploadSuccessful}
					onUploadTeamFavicon={this.onUploadTeamFavicon}
					onSubmit={this.handleTeamSettingsSubmit}
					enableReinitialize="true"
					initialValues={{
						teamName: team,
						teamUrl,
					}}
					teamColorScheme={teamColorScheme}
					onChangeTeamColorScheme={this.changeTeamColorScheme}
					onToggleChangeSlugModal={this.toggleChangeSlugModal}
				/>
				{/* <h2>Advanced settings</h2>
				<AdvancedTeamSettingsForm
					onSubmit={this.handleAdvancedTeamSettingsSubmit}
					enableReinitialize="true"
				/> */}
				{/* <hr />
				<div className="grid" data-grid="wide">
					<div className="grid__item" data-grid--small="6/12">
						<h2>Team deletion</h2>
						<Confirm
							title="Really delete your team?"
							text={(
								<Fragment>
									You are about to delete your team. This action is irrevocable!
								</Fragment>
							)}
						>
							{confirm => (
								<Button
									onClick={
										confirm(() => {
											console.log('Team deleted.')
										})
									}
									text="Delete team"
									layout="ghosted"
								/>
							)}
						</Confirm>
					</div>
				</div> */}

				<Modal
					visible={this.state.changeSlugModalOpen}
					onClose={() => {
						this.setState({ changeSlugModalOpen: false })
					}}
					title={t('forms.change_team_url')}
				>
					<ChangeSlugForm
						onSubmit={this.handleChangeSlugSubmit}
						handleReset={this.toggleChangeSlugModal}
						initialValues={{ teamUrl }}
					/>
				</Modal>

				<Modal
					visible={createTeamModalOpen}
					onClose={this.toggleCreateTeamModal}
					title={t('settings.create_new_team')}
					width="large"
				>
					<CreateTeamForm
						openCreateTeam={openCreateTeam}
						onSubmit={this.handleCreateTeamSubmit}
						handleReset={this.toggleCreateTeamModal}
					/>
				</Modal>
			</>
		)
	}
}

TeamPage.defaultProps = {
	teamImage: null,
	teamLogo: null,
	teamLogoNegative: null,
	teamFavicon: null,
	openCreateTeam: false,
}

const mapStateToProps = state => ({
	loading: state.settings.loading,
	team: state.auth.team.name,
	teamUrl: state.auth.team.slug,
	teamImage: state.auth.team.image,
	teamImageUploadPending: state.settings.teamImageUploadPending,
	teamImageUploadSuccessful: state.settings.teamImageUploadSuccessful,
	teamLogo: state.auth.team.logo,
	teamLogoUploadPending: state.settings.teamLogoUploadPending,
	teamLogoUploadSuccessful: state.settings.teamLogoUploadSuccessful,
	teamLogoNegative: state.auth.team.logoNegative,
	teamLogoNegativeUploadPending: state.settings.teamLogoNegativeUploadPending,
	teamLogoNegativeUploadSuccessful:
		state.settings.teamLogoNegativeUploadSuccessful,
	teamFavicon: state.auth.team.favicon,
	teamFaviconUploadPending: state.settings.teamFaviconUploadPending,
	teamFaviconUploadSuccessful: state.settings.teamFaviconUploadSuccessful,
	teamColorScheme: state.auth.team.colorScheme,
})

const mapDispatchToProps = {
	setLoadingState: settingsActions.setLoadingState,
	updateTeamName: settingsActions.updateTeamNameRequest,
	updateTeamImage: settingsActions.updateTeamImageRequest,
	updateTeamLogo: settingsActions.updateTeamLogoRequest,
	updateTeamLogoNegative: settingsActions.updateTeamLogoNegativeRequest,
	updateTeamFavicon: settingsActions.updateTeamFaviconRequest,
	updateScheme: settingsActions.updateSchemeRequest,
	updateSlug: settingsActions.updateSlugRequest,
	createTeam: authActions.createTeamRequest,
}

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(translate()(TeamPage))
)
